import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface AppVersionInfo {
  version: string;
  android: string;
  ios: string;
}

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  private readonly http = inject(HttpClient);

  fetchMinVersion(): Observable<AppVersionInfo> {
    return this.http
      .get<{ data: AppVersionInfo }>(`${environment.crowdAPIURL}/v1/crowd/version`)
      .pipe(map((response) => response.data));
  }
}
